"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var react_dnd_touch_backend_1 = require("react-dnd-touch-backend");
var react_dropzone_1 = require("react-dropzone");
var react_i18next_1 = require("react-i18next");
var BlDropzoneThumb_1 = __importDefault(require("./BlDropzoneThumb"));
var Sortable_1 = __importDefault(require("./Sortable"));
var useMediaPreview_1 = require("../../../hooks/useMediaPreview");
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var mediaHelper_1 = require("../../../helpers/mediaHelper");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var baseStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
};
var activeStyle = {
    borderColor: '#2196f3',
};
var acceptStyle = {
    borderColor: '#00e676',
};
var rejectStyle = {
    borderColor: '#ff1744',
};
var BlDropzone = function (_a) {
    var _b;
    var _c = _a.values, values = _c === void 0 ? [] : _c, onRemoved = _a.onRemoved, onChange = _a.onChange, onReordering = _a.onReordering, onReordered = _a.onReordered, loadingElement = _a.loadingElement;
    var t = react_i18next_1.useTranslation('common').t;
    var openPreview = useMediaPreview_1.useMediaPreview();
    var _d = react_dropzone_1.useDropzone({
        //TODO get validation rules from backend and implement validation in frontend
        onDrop: function (acceptedFiles) {
            onAdd(acceptedFiles);
        },
    }), getRootProps = _d.getRootProps, getInputProps = _d.getInputProps, isDragActive = _d.isDragActive, isDragAccept = _d.isDragAccept, isDragReject = _d.isDragReject;
    var style = react_1.useMemo(function () { return (__assign(__assign(__assign(__assign({}, baseStyle), (isDragActive ? activeStyle : {})), (isDragAccept ? acceptStyle : {})), (isDragReject ? rejectStyle : {}))); }, [isDragActive, isDragReject, isDragAccept]);
    var onRemove = function (id) {
        onRemoved(id);
    };
    var onAdd = function (files) {
        onChange(files);
    };
    var composePreviewMedia = function () {
        return values.map(function (file) { return (__assign(__assign({}, file), { url: file.path })); });
    };
    var thumbs = values.map(function (file, index) { return (react_1.default.createElement(BlDropzoneThumb_1.default, { path: mediaHelper_1.resolveThumb(file), onClick: function () {
            openPreview(composePreviewMedia(), index);
        }, onRemove: function () {
            onRemove(file.id);
        } })); });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", __assign({}, getRootProps({ style: style })),
            react_1.default.createElement("input", __assign({}, getInputProps(), { className: styles_module_scss_1.default.file_input })),
            react_1.default.createElement("p", null, t('drag_n_drop_images'))),
        loadingElement ? (loadingElement) : (react_1.default.createElement(react_dnd_1.DndProvider, { backend: deviceHelper_1.isMobile() ? react_dnd_touch_backend_1.TouchBackend : react_dnd_html5_backend_1.HTML5Backend },
            react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.thumbsContainer, (_b = {},
                    _b[styles_module_scss_1.default.isEmptyThumbsContainer] = !values.length,
                    _b)) }, thumbs.map(function (t, i) { return (react_1.default.createElement(Sortable_1.default, { key: i, index: i, onMove: onReordering, onDrop: onReordered }, t)); }))))));
};
exports.default = BlDropzone;
